import { ReactComponent as IconTick } from "@/assets/svgs/tick.svg";

const ModalSelectedList = ({ items, title = 'Selected', valueKey = 'name', subValueKey }) => {
	return (
		<>
			<div className="modal-selected-items--text modal-selected-items--border--bottom">
				{title}
			</div>
			<div className='modal-selected-items--table'>
				{items
					.map((item, index) => {
						return (
							<div key={index} className="modal-selected-items--row modal-selected-items--border--bottom">
								<div
									data-testid="role-checkbox"
									className={
										"use-case-request__checkbox use-case-request__checkbox--disabled"
									}
								>
									<IconTick />
								</div>
								<div className="modal-selected-items--row--text">
									<div className="modal-selected-items--row--text--title">
										{item?.[valueKey]}
									</div>
									{item?.[subValueKey] &&
										<div className="modal-selected-items--row--text--subtitle">
											{item?.[subValueKey]}
										</div>
									}
								</div>
							</div>
						);
					})}
			</div>
		</>
	)
};

export default ModalSelectedList;
